import lodashIsEqual from "lodash/isEqual";

import {
  GET_SAVED_SEARCH_QUERIES,
  SAVE_SEARCH_QUERY,
  DELETE_SAVED_SEARCH_QUERY,
  GET_SAVED_SEARCH_DETAILS,
  GET_SAVED_SEARCH_DETAILS_BY_ID,
  MODIFY_SAVED_SEARCH_QUERY,
} from "./actions.type";

import {
  SET_SAVED_SEARCH_QUERIES,
  SET_SAVED_SEARCH_DETAILS,
} from "./mutations.type";

import {
  getSavedSearchList,
  saveSearchQuery,
  deleteSearchQuery,
  updateSearchQuery,
} from "@/services/search/savedSearch.service";
import lodashFind from "lodash/find";

const STATE = {
  queries: [],
  savedSearchDetails: null,
};

const GETTERS = {
  queries: (state) => state.queries,
  savedSearchDetails: (state) => state.savedSearchDetails,
};

const ACTIONS = {
  async [GET_SAVED_SEARCH_QUERIES](context, params) {
    try {
      let res = await getSavedSearchList(params);
      context.commit(SET_SAVED_SEARCH_QUERIES, res);
    } catch (error) {
      console.error("Error in GET_SAVED_SEARCH_QUERIES action: " + error);
    }
  },
  async [SAVE_SEARCH_QUERY](context, data) {
    try {
      if (data) {
        await saveSearchQuery(data);
      }
      await context.dispatch(GET_SAVED_SEARCH_QUERIES);
    } catch (error) {
      console.error("Error in SAVE_SEARCH_QUERY action: " + error);
    }
  },
  async [DELETE_SAVED_SEARCH_QUERY](context, data) {
    try {
      if (data) {
        await deleteSearchQuery(data);
      }
      await context.dispatch(GET_SAVED_SEARCH_QUERIES);
    } catch (error) {
      console.error("Error in DELETE_SAVED_SEARCH_QUERY action: " + error);
    }
  },
  [GET_SAVED_SEARCH_DETAILS](context, data) {
    if (lodashIsEqual(data, STATE.savedSearchDetails)) {
      return;
    }
    context.commit(SET_SAVED_SEARCH_DETAILS, data);
  },
  [GET_SAVED_SEARCH_DETAILS_BY_ID](context, data) {
    const savedSearchDetails = lodashFind(STATE.queries, [
      "saved_search_id",
      data,
    ]);
    if (
      !savedSearchDetails ||
      lodashIsEqual(savedSearchDetails, STATE.savedSearchDetails)
    ) {
      return;
    }
    context.commit(SET_SAVED_SEARCH_DETAILS, savedSearchDetails);
  },
  async [MODIFY_SAVED_SEARCH_QUERY](context, data) {
    try {
      if (data) {
        const savedSearchDetails = await updateSearchQuery(data);
        context.commit(SET_SAVED_SEARCH_DETAILS, savedSearchDetails);
      }
      await context.dispatch(GET_SAVED_SEARCH_QUERIES);
    } catch (error) {
      console.error("Error in MODIFY_SAVED_SEARCH_QUERY action: " + error);
    }
  },
};

const MUTATIONS = {
  [SET_SAVED_SEARCH_QUERIES](state, data) {
    state.queries = data;
  },
  [SET_SAVED_SEARCH_DETAILS](state, data) {
    state.savedSearchDetails = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
